import React, { useMemo } from 'react'

import type { Product } from '../../../../../../../../../__models__'
import { ExplanationText } from '../../../../../../components/ExplanationText/ExplanationText'
import { getEstimatedProductionTime } from './getEstimatedProductionTime'

type OnDemandListingProps = {
  product: Product
}
export const OnDemandListing = ({ product }: OnDemandListingProps) => {
  const { from, to } = useMemo(() => getEstimatedProductionTime(product), [product])
  const PRODUCTION_TIME_TEXT = from === to ? from : `${from}-${to}`

  return (
    <ExplanationText
      title="On demand"
      subtitle={`This product is produced to order. Orders ship within ${PRODUCTION_TIME_TEXT} days of being placed.`}
    />
  )
}
